/* eslint no-use-before-define: 0 */
const _ = require('lodash');
/*:: type FieldDefinition = {
  name?: string,
  desc: string,
  required: boolean,
  default: any,
  type: string,
  source: string,
  values?: Array<any>
};*/

/*:: type FlowTemplate = {
  vars: { [string]: FieldDefinition }
}*/

/*:: type FlowInitObj = {
  id?: string;
  created?: string;
  vars?: {};
  validators?: {};
  flow?: {};
  template: FlowTemplate;
};*/


const getDefaultValues = (template
/*: FlowTemplate*/
) =>
/*: { [string]: FieldDefinition }*/
{
  const {
    vars
  } = template; // uuid fields can't have meaningful default values

  return _.mapValues(vars, fieldDefinition => fieldDefinition.type === 'uuid' ? undefined : fieldDefinition.default);
};

const makeFieldDefinition = (name
/*: string*/
, base
/*: FieldDefinition*/
, val
/*: any*/
) =>
/*: FieldDefinition*/
{
  switch (name) {
    case 'redeemSegmentId':
      // fake default value so we can toggle it on and off in the UI
      return Object.assign({
        name
      }, base, {
        default: val
      });

    default: // fall through

  }

  return Object.assign({
    name
  }, base);
}; // Conditionally wrap and unwrap so we can handle both simple strings and translation maps


const unwrapLocale = values => {
  if (typeof values === 'object') return values.default;
  return values;
};

const wrapLocale = value => {
  // If undefined or null, send `undefined` so it picks up the default
  if (value == null) return undefined;
  if (typeof value === 'object') return value; // Yes, this is on purpose
  // noinspection UnnecessaryLocalVariableJS

  const returnValue = value;
  return {
    default: returnValue
  };
};

const unwrapTextLocales = (values, templateFields) => _.mapValues(values, (value, key) => {
  if (templateFields[key] && templateFields[key].type === 'text') return unwrapLocale(value);
  return value;
});

const wrapTextLocales = (values, templateFields) => _.mapValues(values, (value, key) => {
  if (templateFields[key] && templateFields[key].type === 'text') return wrapLocale(value);
  return value;
});

class Flow {
  /*:: static fromJson: (Object) => Flow */

  /*:: static serialize: (Flow) => Object */

  /*:: static validate: ({String:FieldDefinition}, Object) => boolean */
  constructor({
    /*: FlowInitObj*/

    id,
    created,
    vars,
    validators,
    flow,
    template
  } = {}) {
    this.id = id;
    this.vars = prepareVars(vars, template);
    this.template = template;
    this.fields = _.toPairs(template.vars).map(([key, defn]) => {
      const val = this.vars[key];
      return makeFieldDefinition(key, defn, val);
    });
  }

}

function prepareVars(vars, template) {
  const bareVars = vars || getDefaultValues(template);
  Flow.validate(template.vars, bareVars);
  const filteredVars = Object.entries(bareVars).filter(([key, value]) => template.vars[key]).reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
  return unwrapTextLocales(filteredVars, template.vars);
}

Flow.validate = (templateVars, vars) => Object.entries(vars).every(([key, value]) => {
  const defn = templateVars[key];

  if (!defn) {
    /* eslint-disable-next-line no-console */
    console.warn(`Extra variable for template "${key}"`);
    return false;
  }

  if (value == null || value === '') {
    if (defn.required) throw new Error(`Missing required template value "${key}"`);
    return true;
  }

  if (defn.type === 'enum') {
    if (defn.values && !defn.values.includes(value)) throw new Error(`Invalid template value for enum "${key}"`);
  }

  if (defn.type === 'integer') {
    if (typeof value !== 'number') throw new Error(`Invalid template value for integer "${key}"`);
    if (value < defn.min) throw new Error(`Value too low for template variable "${key}"`);
    if (value > defn.max) throw new Error(`Value too high for template variable "${key}"`);
  }

  if (defn.type === 'boolean') {
    if (typeof value !== 'boolean') throw new Error(`Invalid template value for boolean "${key}"`);
  }

  return true;
});

Flow.fromJson = (json
/*: Object*/
) =>
/*: Flow*/
new Flow(json);

Flow.serialize = (flow
/*: Flow*/
) => (
/*: Object*/
{
  vars: wrapTextLocales(flow.vars, flow.template.vars),
  template: flow.template
});

module.exports = Flow;